import React from 'react';
import HomeSection1 from "./home-section1";
import HomeSection2 from './home-section2';
import HomeSection3 from './home-section3';
import HomeSection4 from './home-section4';
import MapView from './home-section5';
import HomeSection6 from './home-section6';
import HomeSection7 from './home-section7';
import './home-styles/home.scss';
const Home = () => {
    return (
        <div>
            <HomeSection1 />
            <HomeSection2 />
            <HomeSection3 />
            <HomeSection4 />
            <HomeSection7 />
            <MapView />
            <HomeSection6 />

            {/* WhatsApp Floating Icon */}
            <a 
                href="https://wa.me/917871051549" // replace with your WhatsApp number
                className="whatsapp-float" 
                target="_blank" 
                rel="noopener noreferrer"
            >
                <img 
                    src="https://img.icons8.com/color/48/000000/whatsapp--v1.png" 
                    alt="WhatsApp" 
                />
            </a>
        </div>
    );
};

export default Home;
